import styled from 'styled-components'
export const TitleWrapper = styled.div`
    padding: 0 ${(props) => props.theme.size.static200};
    background-color: ${({theme}) => theme.colors.background.primary};
    position: relative;
    width: fit-content;
`
export const TitleContainer = styled.div<{$dividerColor?: string}>`
    margin: ${(props) => props.theme.size.static520} 0
        ${(props) => props.theme.size.static550} 0;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        background-color: ${({$dividerColor, theme}) =>
            $dividerColor ?? theme.colors.border.default};
        width: 100vw;
        height: ${({theme}) => theme.size.border.active};
        top: 50%;
        transform: translateY(-50%);
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
    }

    &-opacity {
        &:before {
            opacity: 0.5;
        }
    }
`

export const VisuallyHidden = styled.span`
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`
